// extracted by mini-css-extract-plugin
export default {"errorModalContentContainer":"ErrorContent_errorModalContentContainer__WMEg2","errorModalButtonContainer":"ErrorContent_errorModalButtonContainer__Xo5f+"};